<div>
<mat-calendar #calendar [(selected)]="selectedDate" 
activeDate="closedDate"
startView="multi-year"
(click)="customCalClick($event)"
(selectedChange)="dateChanged($event)">
>														
</mat-calendar> 
<div><!-- bottom button bar -->
<button color="primary" mat-raised-button  (click)="customCalBtnClick($event)">Today</button>&nbsp;
<button color="warn" mat-raised-button  (click)="customCalBtnClick($event)">Clear</button>&nbsp;
<button color="primary" mat-raised-button  style="float:right" (click)="customCalBtnClick($event)">Done</button>
</div>
</div>
